module.exports = __webpack_public_path__ + "img/biote-white-logo.53668d6d.png";